"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShapes = exports.useMapFeatures = exports.getRegionProjection = exports.getProjection = void 0;
const d3_geo_1 = require("d3-geo");
const react_1 = require("react");
const topojson_client_1 = require("topojson-client");
const ne_110m_land_json_1 = __importDefault(require("../../data/ne_110m_land.json"));
// Calculate projection translation from zoom level and offset
const getTranslate = (width, height, zoom) => [
    (zoom.k * width) / 2 + zoom.x,
    (zoom.k * height) / 2 + zoom.y,
];
const getProjection = (width, height, heightFactor, zoomState) => {
    const scaleFactor = Math.min(width, height / heightFactor) * 0.22;
    return (0, d3_geo_1.geoNaturalEarth1)()
        .rotate([-14, 0.0])
        .center([0.0, 14])
        .translate(getTranslate(width, height, zoomState))
        .scale(scaleFactor * zoomState.k)
        .precision(0.1);
};
exports.getProjection = getProjection;
const getRegionProjection = (width, height, heightFactor, zoomState) => {
    const scaleFactor = Math.min(width, height / heightFactor) * 1.2;
    return (0, d3_geo_1.geoTransverseMercator)()
        .rotate([-118.5715027, 0])
        .center([0, -8])
        .translate([width / 2, height / 2])
        .scale(scaleFactor * zoomState.k)
        .precision(0.1);
};
exports.getRegionProjection = getRegionProjection;
const useMapFeatures = () => {
    const [mapFeatures] = (0, react_1.useMemo)(() => {
        const features = (0, topojson_client_1.feature)(ne_110m_land_json_1.default, ne_110m_land_json_1.default.objects["ne_110m_land"]);
        return [features];
    }, []);
    return [mapFeatures];
};
exports.useMapFeatures = useMapFeatures;
const getShapes = (projection, geometry) => {
    const generator = (0, d3_geo_1.geoPath)(projection);
    return geometry.features.map((f) => generator(f.geometry));
};
exports.getShapes = getShapes;
